function StatusColumn({ value }) {
  return value ? <i className="fa fa-times text-danger"></i> : <i className="fa fa-check text-success"></i>;
}

export default StatusColumn;
